import { MerchantAppReturnZodSchema } from "@redotech/redo-model/return";
import * as z from "zod/v4";

export const getReturn = {
  name: "getReturn" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({ data: MerchantAppReturnZodSchema }),
};
